import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Button } from 'antd';
import { AuthContext } from '../LocalAuthWrapper';
import { NavLinkWithToken as NavLink } from '../LinkWithToken';
import { isFeatureEnabled } from '../features';

import './Navigation.css';
import { CloseOutlined } from '@ant-design/icons';

type Props = {
  hideMenu: () => void;
  visible?: boolean;
} & RouteComponentProps;

interface State {}

class Navigation extends React.Component<Props, State> {
  private navRef = React.createRef<HTMLDivElement>();
  private timeout!: any;

  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  componentWillUnmount = () => {
    clearTimeout(this.timeout);
  };

  hideWithDelay = () => {
    const { hideMenu } = this.props;
    this.timeout = setTimeout(hideMenu, 100);
  };

  render() {
    const {
      location: { pathname },
      visible,
    } = this.props;
    return (
      <AuthContext.Consumer>
        {(value) => (
          <div ref={this.navRef} tabIndex={0} className={`navigation-container ${visible ? 'visible' : ''}`}>
            <div className='navigation-title'>
              <img src='/tiro_logo.png' alt='Tiro Logo' />
              <span className='title'>Talgreinir</span>
              <Button icon={<CloseOutlined />} onClick={this.hideWithDelay} />
            </div>
            <div className={'navigation-divider'} />
            <div className={'navigation-options'}>
              <NavLink className={`navigation-link`} to='/' exact>
                <div className={`navigation-bulletin ${pathname === '/' ? 'active' : ''}`} />
                <span>Heim</span>
              </NavLink>
              <NavLink className={`navigation-link`} activeClassName='active' to='/editor'>
                <div className={`navigation-bulletin ${pathname === '/editor' ? 'active' : ''}`} />
                <span>Diktering</span>
              </NavLink>
              {isFeatureEnabled('REAL_TIME_CAPTIONING') && (
                <NavLink className={`navigation-link`} activeClassName='active' to='/rauntimatextun/broadcasts'>
                  <div
                    className={`navigation-bulletin ${pathname.includes('/rauntimatextun/broadcasts') ? 'active' : ''}`}
                  />
                  <span>Rauntímatextun</span>
                </NavLink>
              )}
              <div className={'navigation-divider'} />
              <div className={'navigation-options'}>
                <Button color='blue' onClick={() => value.signOut()}>
                  {`Skrá út (${
                    value.userDetails
                      ? value.userDetails.displayName
                        ? value.userDetails.displayName
                        : value.userDetails.email
                      : 'N/A'
                  })`}
                </Button>
              </div>
            </div>
          </div>
        )}
      </AuthContext.Consumer>
    );
  }
}

export default withRouter(Navigation);
